import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Blank = props => (
  <StyledIcon viewBox='0 0 24 24' aria-hidden={true} {...props} />
);
